const store = {
    namespaced: true,
    state: {
        categories: [],
        current_category: null,
    },
    getters: {
    },
    mutations: {
    }
}

export default store
